module.exports = __webpack_public_path__ + "img/title2.1bdfc5ca.png";